import type { AgrProcessEnv } from '@next/core-lib/environment';

import { setEnvironment, type Environment } from '../environment';

export const environmentProcessEnv = {
  APPLICATION_NAME: 'Pig',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'https://pig.agrifirm.com',
  LOGIN_TYPE: 'redirect',
  SIGNUP_SIGNIN_POLICY: 'B2C_1A_AllAccountsSignupSignin',
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  API_BASE_URL: 'https://pig.agrifirm.com',
  APPLICATION_KEY: 'Pig',
  DEFAULT_LOCALE: 'nl-NL',
  LOCALES: 'nl-NL,en-US',
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  PRODUCTION: 'true',
  RELATIONSHIPS_ELASTIC_SEARCH: 'true',
  CUSTOMER_IN_LOCATION_SELECTOR: 'true',
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  NEDAP_BASE_URL: 'https://nedap-bi.com',
  NEDAP_CLIENT_ID: 'e0016a88a1e7e7d84b45f468ed8a85a22f0145b47e5c22454fb684a49044a3f5',
  NEDAP_REDIRECT_URI: 'https://pig.agrifirm.com/third-parties/nedap/response',
  NEDAP_WORKSPACE_ID: '7738dfd0-2b66-48c6-bc14-56bb86f7d525',
  NEDAP_REPORT_ID: '27ec31cf-eb19-4a64-9987-b57266081fae',
  KUBE_POD_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_TEAM: '',
} as AgrProcessEnv;

export const environment: Environment = setEnvironment(environmentProcessEnv);
